import { request } from './client';

export const apiGetWishlist = () => request('/wishlist');

export const apiAddToWishlist = (bookId) =>
  request('/wishlist', { method: 'POST', body: { bookId } });

export const apiRemoveFromWishlist = (bookId) =>
  request(`/wishlist/${bookId}`, { method: 'DELETE' });
